<template>
	<dashboard-dropdown-section
		:title="getLabel('upcomingBookingsTitle', 'Upcoming Bookings')"
		class="mt-4"
		type="locum-upcoming-bookings"
		:items-shown="5"
		:items="bookings"
		event-name="load-locum-upcoming-bookings"
		@load-locum-upcoming-bookings="loadMore"
	/>
</template>

<script>
import { mapActions } from 'vuex';

import DashboardDropdownSection from '@/components/custom/DashboardDropdownSection';

export default {
	name: 'PracticeUpcomingBookings',

	components: { DashboardDropdownSection },

	data: () => ({
		bookings: [],
	}),

	methods: {
		...mapActions('bookings', ['FetchProfessionalBookings']),

		async loadMore(event) {
			const { startDate, endDate } = event;

			const bookings = await this.FetchProfessionalBookings({ startDate, endDate });
			this.bookings = bookings.map(booking => ({ ...booking, event_start_date: booking.start_date }));
		},
	},
};
</script>
